import { useIntl } from 'react-intl';
import { CircularProgress, Stack, Typography } from '@rossum/ui/material';

const statusSx = { height: '100%', width: '100%' } as const;

export const SplitScreenLoading = () => {
  const intl = useIntl();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={statusSx}
      data-cy="split-screen-loading"
    >
      <CircularProgress
        aria-label={intl.formatMessage({
          id: 'features.documentSplit.loading.label',
        })}
      />
    </Stack>
  );
};

export const SplitScreenMessage = ({
  messageId,
  dataCy,
}: {
  messageId:
    | 'features.documentSplit.notFound.title'
    | 'features.documentSplit.conflict.title';
  dataCy: string;
}) => {
  const intl = useIntl();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={statusSx}
      data-cy={dataCy}
    >
      <Typography variant="h6">
        {intl.formatMessage({ id: messageId })}
      </Typography>
    </Stack>
  );
};
